import React, {useRef} from 'react'
import {useInputValue} from '@modifi/plugin-forms'
import {City, TRADE_PARTNER_CITY} from '@modifi/plugin-onboarding'

export const CustomCity: React.FC<{}> = props => {
  const {value: city} = useInputValue({name: TRADE_PARTNER_CITY})

  const disableRef = useRef(true)

  if (!city) {
    disableRef.current = false
  }

  // @ts-expect-error property is a string
  return <City {...props} required {...(disableRef.current ? {} : {disabled: false})} />
}
